import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import _ from 'underscore';

import {
  Checkbox,
  FormControlLabel,
  MenuItem,
  TextField,
} from '@material-ui/core';

import Confirm from 'common/components/Confirm';
import messages from 'ondemand/messages';

import styles from './PassengerDetailsInput.css';


class PassengerDetailsInput extends React.Component {
  static displayName = 'PassengerDetailsInput';

  static propTypes = {
    agencySettings: PropTypes.object,
    capacity: PropTypes.number,
    maxCapacity: PropTypes.number,
    wheelchair: PropTypes.bool,
    bicycle: PropTypes.bool,
    onCapacityChange: PropTypes.func,
    onWheelchairChange: PropTypes.func,
    onBicycleChange: PropTypes.func,
  };

  static defaultProps = {
    maxCapacity: 20,
  };

  state = {
    contactVisible: false,
  };
  render() {
    const hasContactInfo = this.props.agencySettings.email || this.props.agencySettings.phone;

    const contactDialog = (
      <Confirm
        cancelButtonText="Close"
        hideConfirm
        message={
          <div className="confirm-dialog-body">
            {this.props.agencySettings.email &&
              <div className={styles.contactItem}>
                <div>Email</div>
                <a
                  className={styles.contactLink}
                  href={`mailto:${this.props.agencySettings.email}`}
                  data-id="agency-email"
                >
                  {this.props.agencySettings.email}
                </a>
              </div>
            }
            {this.props.agencySettings.phone &&
              <div className={styles.contactItem}>
                <div>Phone</div>
                <a
                  className={styles.contactLink}
                  href={`tel:${this.props.agencySettings.phone}`}
                  data-id="agency-phone"
                >
                  {this.props.agencySettings.phone}
                </a>
              </div>
            }
          </div>
        }
        open={this.state.contactVisible}
        onCancel={() => this.setState({contactVisible: false})}
        title="Agency Contact"
      />
    );

    return (
      <div className={styles.root}>
        {contactDialog}
        <div className={styles.title}>Passenger Details</div>
        <div className={styles.subtitle}>
          Select the number of passengers that will be on this ride.
        </div>

        <div className={styles.capacity}>
          <TextField
            onChange={(event) => this.props.onCapacityChange(event.target.value)}
            select
            SelectProps={{
              SelectDisplayProps: {
                'data-id': 'capacity-select',
              },
            }}
            value={this.props.capacity}
          >
            {_.map(
              _.range(1, this.props.maxCapacity + 1),
              (i) => (
                <MenuItem
                  key={i}
                  data-id={`capacity-select-${i}`}
                  value={i}
                >
                  {i}
                </MenuItem>
              ),
            )}
          </TextField>
        </div>
        <div className={styles.optionalRequirement}>
          <FormControlLabel
            data-id="wheelchair-container"
            checked={this.props.wheelchair}
            control={
              <Checkbox color="primary" />
            }
            disabled={!this.props.onWheelchairChange}
            label="Wheelchair access required"
            onChange={(event, checked) => this.props.onWheelchairChange(checked)}
          />
          {!this.props.onWheelchairChange &&
            <div
              className={classNames(
                {[styles.optionalMessageClickable]: hasContactInfo},
                styles.optionalMessage
              )}
              onClick={() => hasContactInfo && this.setState({contactVisible: true})}
            >
              {hasContactInfo ? messages.noWheelchairWithContact : messages.noWheelchair}
            </div>
          }
        </div>
        <div className={styles.optionalRequirement}>
          <FormControlLabel
            data-id="bicycle-container"
            checked={this.props.bicycle}
            control={
              <Checkbox color="primary" />
            }
            disabled={!this.props.onBicycleChange}
            label="Bicycle required"
            onChange={(event, checked) => this.props.onBicycleChange(checked)}
          />
          {!this.props.onBicycleChange &&
            <div
              className={classNames(
                {[styles.optionalMessageClickable]: hasContactInfo},
                styles.optionalMessage
              )}
              onClick={() => hasContactInfo && this.setState({contactVisible: true})}
            >
              {hasContactInfo ? messages.noBicycleWithContact : messages.noBicycle}
            </div>
          }
        </div>

      </div>
    );
  }
}

export default PassengerDetailsInput;



// WEBPACK FOOTER //
// ./src/ondemand/components/PassengerDetailsInput/PassengerDetailsInput.js